import React from "react";
import PropTypes from 'prop-types';

export default function EventSyncAlert({ message, onRevert }) {
  return (
    <div className="alert alert-danger">
      <p>{message}</p>
      <br/>
      <br/>
      <button data-test-id="event-revert-button" className="btn btn-secondary" onClick={onRevert}>Revert Configuration</button>
    </div>
  );
}

EventSyncAlert.propTypes = {
  message: PropTypes.string.isRequired,
  onRevert: PropTypes.func.isRequired
};
